/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEstimateItemDto } from './GetEstimateItemDto';
import {
    GetEstimateItemDtoFromJSON,
    GetEstimateItemDtoFromJSONTyped,
    GetEstimateItemDtoToJSON,
} from './GetEstimateItemDto';

/**
 * 
 * @export
 * @interface GetOrderEstimateItemDto
 */
export interface GetOrderEstimateItemDto {
    /**
     * 
     * @type {string}
     * @memberof GetOrderEstimateItemDto
     */
    id: string;
    /**
     * 
     * @type {GetEstimateItemDto}
     * @memberof GetOrderEstimateItemDto
     */
    estimateItem: GetEstimateItemDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderEstimateItemDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetOrderEstimateItemDto interface.
 */
export function instanceOfGetOrderEstimateItemDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "estimateItem" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetOrderEstimateItemDtoFromJSON(json: any): GetOrderEstimateItemDto {
    return GetOrderEstimateItemDtoFromJSONTyped(json, false);
}

export function GetOrderEstimateItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrderEstimateItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'estimateItem': GetEstimateItemDtoFromJSON(json['estimateItem']),
        'active': json['active'],
    };
}

export function GetOrderEstimateItemDtoToJSON(value?: GetOrderEstimateItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'estimateItem': GetEstimateItemDtoToJSON(value.estimateItem),
        'active': value.active,
    };
}

